<div class="ptb-60">
    <div class="container-fluid bg-breadcrumb mx-0 w-auto">
        <div class="container text-center mleft">
            <div class="row">
                <div class="col-lg-9">
                    <div class="search-container d-none d-lg-block">
                        <div class="search-bar">
                            <div class="d-flex flex-column ">
                                <input type="text" [(ngModel)]="skills"
                                       (ngModelChange)="onSearchInputChange('skills', $event)"
                                       class="search-input input_radius fs-14 radius" placeholder="Skills">
                                <ul *ngIf="suggestedSkills.length > 0 && showSuggestions"
                                    class="autocomplete-dropdown dropdownchg">

                                    <li *ngFor="let skill of suggestedSkills"
                                        (click)="selectSkill(skill.SkillName)">
                                        {{ skill.SkillName }}
                                    </li>
                                </ul>
                                </div>
                                <div class="d-flex flex-column ">
                                    <input type="text" [(ngModel)]="location"
                                           (ngModelChange)="onSearchInputChange1('location', $event)"
                                           class="search-input fs-14" placeholder="Location">
                                    <ul *ngIf="suggestedLocations.length > 0 && showLocationSuggestions"
                                        class="autocomplete-dropdown location-dropdown dropdownchg">

                                        <li *ngFor="let loc of suggestedLocations"
                                            (click)="selectLocation(loc.LocationName)">
                                            {{ loc.LocationName }}
                                        </li>
                                    </ul>
                                    </div>
                                    <select [(ngModel)]="selectedExperience" class="experience-dropdown fs-14">
                                        <option value="">Exp</option>
                                        <option *ngFor="let option of experienceOptions" [value]="option">{{ option }}</option>
                                    </select>
                                    <button class="find-jobs-btn" (click)="findJobs()">Find Jobs</button>
                                </div>
                            </div>
                    <!--<div class="search-container d-lg-none">
                        <div class="search-bar">
                            <input type="text" [(ngModel)]="skills"
                                   (ngModelChange)="onSearchInputChange('skills', $event)"
                                   class="search-input input_radius fs-14" placeholder="Skills">
                            <ul *ngIf="suggestedSkills.length > 0 && showSuggestions"
                                class="autocomplete-dropdown">

                                <li *ngFor="let skill of suggestedSkills"
                                    (click)="selectSkill(skill.SkillName)">
                                    {{ skill.SkillName }}
                                </li>
                            </ul>

                            <input type="text" [(ngModel)]="location"
                                   (ngModelChange)="onSearchInputChange1('location', $event)"
                                   class="search-input fs-14" placeholder="Location">
                            <ul *ngIf="suggestedLocations.length > 0 && showLocationSuggestions"
                                class="autocomplete-dropdown location-dropdown">

                                <li *ngFor="let loc of suggestedLocations"
                                    (click)="selectLocation(loc.LocationName)">
                                    {{ loc.LocationName }}
                                </li>
                            </ul>
                            <select [(ngModel)]="selectedExperience" class="experience-dropdown fs-14">
                                <option value="">Exp</option>
                                <option *ngFor="let option of experienceOptions" [value]="option">{{ option }}</option>
                            </select>
                            <button class="find-jobs-btn" (click)="findJobs()"><i class="fas fa-search"></i></button>
                        </div>
                    </div>-->
                </div>
                <div class="col-lg-3 d-none d-lg-block">
                    <div class="upload-container  mtop">
                        <a (click)="uploadresume()" class="upload-resume-btn"><i class="fa-solid fa-upload"></i> Upload Your Resume</a>
                    </div>
                </div>
            </div>
        </div>
    </div><br />
    <!-- filter -->
    <div class="container">
        <div class="row">
            <!-- filter start -->
            <button class="filter-toggle-btn d-lg-none" (click)="toggleFilter()">
                <i class="fas fa-sliders-h"></i>
            </button>
            <div class="col-lg-3  col-sm-3 border p-3 mb-3 rounded-2" [class.active]="isFilterActive">
                <h3 class="filter-title"><i class="fas fa-filter"></i> ALL FILTERS</h3>
                <div class="filter-section">
                    <h4>Companies</h4>
                    <ul class="filter-list">
                        <li *ngFor="let item of careerdata">
                            <input type="checkbox" id="company1" [checked]="selectedCompany === item.CompanyName"
                                   (change)="onCompanySelect(item.CompanyName)">
                            <label style="cursor: pointer;" for="company1" (click)="Companyfilter(item.CompanyName)">{{item.CompanyName}}</label>
                        </li>
                    </ul>
                    <!--<a href="#" class="view-more">View more</a>-->
                </div>

                <div class="filter-section">
                    <h4>Specialization</h4>
                    <ul class="filter-list">
                        <li *ngFor="let item of specalizationdata">
                            <input type="radio" id="specialization1" [checked]="SelectedDomain === item.WorkingDomains"
                                   (change)="onSelectWorking(item.WorkingDomains)">
                            <label for="specialization1">{{item.WorkingDomains}}</label>
                        </li>
                    </ul>
                    <!--<a href="#" class="view-more">View more</a>-->
                </div>

                <div class="filter-section">
                    <h4>Experience</h4>
                    <ul class="filter-list">
                        <li *ngFor="let item of Experiencedata">
                            <input type="radio" name="experience" id="experience1" [checked]="SelectedYear === item.Experience"
                                   (change)="onSelectedyear(item.Experience)">
                            <label for="experience1">{{item.MExperience}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="filter-overlay" [class.active]="isFilterActive" (click)="closeFilter()"></div>

            <!-- filter end -->
            <!-- post job start -->
            <div class="col-lg-9 col-sm-9">
                <div class="job-container">

                    <!-- Regular Jobs Section -->
                    <div class="job-header" *ngIf="!matchingJobsData && !Domainfilter">
                        <h2>{{ paginatedJobs ? paginatedJobs.length : 0 }}&nbsp; Jobs out of {{ jobs ? jobs.length : 0 }}</h2>
                        <div class="sort-options">
                            <span>Sort by freshness: Last {{ timeGap }}</span>
                        </div>
                    </div>

                    <div class="job-listing" *ngIf="!matchingJobsData && !Domainfilter">
                        <div *ngIf="jobs && jobs.length > 0; else noJobsFoundRegular">
                            <div *ngFor="let job of paginatedJobs" class="job-card">
                                <div class="job-info">
                                    <h3>{{ job.WorkingDomains }} <span>(More Jobs)</span></h3>
                                    <p class="company-name">{{ job.CompanyName }}</p>
                                    <p class="company-name"><b>Posted by:</b> {{ job.RecruiterName }}</p>

                                    <div class="job-meta">
                                        <span>Required Position: {{ job.RequiredPosition || 'Not defined' }}</span> |
                                        <span>Experience: {{ job.MExperience || 'Not defined' }}</span> |
                                        <span>₹ {{ job.SalaryRange || 'Not defined' }}</span> |
                                        <span><i class="fas fa-map-marker-alt"></i> {{ job.CityName || 'Location not defined' }} | {{ job.TypeName }}</span>
                                    </div>
                                    <p class="job-description">
                                        <strong>Job Description:</strong> {{ job.JobDescription || 'No description available' }}
                                    </p>
                                    <p class="keyskills">
                                        <strong>KeySkills:</strong> {{ job.RequiredSkills }}, {{ job.MantatorySkills }}
                                    </p>
                                </div>
                                <div class="apply-btn">
                                    <!-- Only show Apply button since applied jobs are hidden -->
                                    <button (click)="applujob(job)">Apply</button>
                                </div>
                            </div>
                        </div>

                        <!-- No Jobs Found Template for Regular Jobs -->
                        <ng-template #noJobsFoundRegular>
                            <div class="no-jobs-container">
                                <p class="no-jobs-message">No jobs found for the selected criteria.</p>
                                <p class="no-jobs-submessage" *ngIf="LoginDetails && appliedPIDs && appliedPIDs.size > 0">
                                    Note: Jobs you've already applied for are hidden from the list.
                                </p>
                            </div>
                        </ng-template>

                        <!-- Pagination Controls -->
                        <div class="paginat" *ngIf="jobs && jobs.length > 0">
                            <button (click)="previousPage()" [disabled]="currentPage === 1"><<<</button>
                            {{ currentPage }}
                            <button (click)="nextPage()" [disabled]="currentPage >= totalPages">>>></button>
                        </div>
                    </div>

                    <!-- Matching Jobs Section -->
                    <div class="job-header" *ngIf="matchingJobsData && matchingJobsData.length > 0">
                        <h2>{{ matchedJobsCount }} Jobs Found Matching Your Skills</h2>
                        <div class="sort-options">
                            <span>Sorted by Match Score</span>
                        </div>
                    </div>

                    <div class="job-listing" *ngIf="matchingJobsData && matchingJobsData.length > 0; else noMatchingJobsFound">
                        <div *ngFor="let job of matchingJobsData" class="job-card">
                            <div class="job-info">
                                <h3>{{ job.WorkingDomains }} <span>(More Jobs)</span></h3>
                                <p class="company-name">{{ job.CompanyName }}</p>
                                <p><b>Posted by:</b> {{ job.RecruiterName }}</p>
                                <div class="job-meta">
                                    <span>Required Position: {{ job.RequiredPosition || 'Not defined' }}</span> |
                                    <span>Experience: {{ job.MExperience || 'Not defined' }}</span> |
                                    <span>₹ {{ job.SalaryRange || 'Not defined' }}</span> |
                                    <span><i class="fas fa-map-marker-alt"></i> {{ job.CityName || 'Location not defined' }}</span>
                                </div>
                                <p class="job-description">
                                    <strong>Job Description:</strong> {{ job.JobDescription || 'No description available' }}
                                </p>
                                <p class="keyskills">
                                    <strong>Required Skills:</strong> {{ job.RequiredSkills }}, {{ job.MantatorySkills }}
                                </p>
                            </div>
                            <div class="apply-btn">
                                <!-- Only show Apply button since applied jobs are hidden -->
                                <button (click)="applujob(job)">APPLY</button>
                            </div>
                        </div>

                        <!-- Pagination for Matching Jobs -->
                        <div class="paginat" *ngIf="matchingJobsData && matchingJobsData.length > pageSize">
                            <button (click)="previousPage()" [disabled]="currentPage === 1"><<<</button>
                            {{ currentPage }}
                            <button (click)="nextPage()" [disabled]="currentPage >= totalPages">>>></button>
                        </div>
                    </div>

                    <!-- No Matching Jobs Found Template -->
                    <ng-template #noMatchingJobsFound>
                        <div class="no-jobs-container" *ngIf="matchingJobsData !== undefined">
                            <p class="no-jobs-message">No matching jobs found based on your skills.</p>
                            <p class="no-jobs-submessage" *ngIf="LoginDetails && appliedPIDs && appliedPIDs.size > 0">
                                Note: Jobs you've already applied for are hidden from the list.
                            </p>
                        </div>
                    </ng-template>

                    <!-- Company Filtered Jobs Section -->
                    <div class="job-header" *ngIf="filterCompany && filterCompany.length > 0">
                        <h2>{{ filterCompany ? filterCompany.length : 0 }}&nbsp;&nbsp; Job Found on {{ CompanyName }}</h2>
                        <div class="sort-options">
                            <span>Sort by freshness: Last {{ timeGap }}</span>
                        </div>
                    </div>

                    <div class="job-listing" *ngIf="filterCompany && filterCompany.length > 0; else noCompanyJobsFound">
                        <div *ngFor="let filter of filterCompany" class="job-card">
                            <div class="job-info">
                                <h3>{{ filter.WorkingDomains }} <span>(More Jobs)</span></h3>
                                <p class="company-name">{{ filter.CompanyName }}</p>
                                <p>Posted by: {{ filter.RecruiterName }}</p>
                                <div class="job-meta">
                                    <span>Required Position: {{ filter.RequiredPosition || 'Not defined' }}</span> |
                                    <span>Experience: {{ filter.MExperience || 'Not defined' }}</span> |
                                    <span>₹ {{ filter.SalaryRange || 'Not defined' }}</span> |
                                    <span><i class="fas fa-map-marker-alt"></i> {{ filter.CityName || 'Location not defined' }} | {{ filter.TypeName }}</span>
                                </div>
                                <p class="job-description">
                                    <strong>Job Description:</strong> {{ filter.JobDescription || 'No description available' }}
                                </p>
                                <p class="keyskills">
                                    <strong>KeySkills:</strong> {{ filter.RequiredSkills }}, {{ filter.MantatorySkills }}
                                </p>
                            </div>
                            <div class="apply-btn">
                                <!-- Only show Apply button since applied jobs are hidden -->
                                <button (click)="applujob(filter)">APPLY</button>
                            </div>
                        </div>
                    </div>

                    <!-- No Company Jobs Found Template -->
                    <ng-template #noCompanyJobsFound>
                        <div class="no-jobs-container" *ngIf="filterCompany !== undefined">
                            <p class="no-jobs-message">No jobs found for the selected company criteria.</p>
                            <p class="no-jobs-submessage" *ngIf="LoginDetails && appliedPIDs && appliedPIDs.size > 0">
                                Note: Jobs you've already applied for are hidden from the list.
                            </p>
                        </div>
                    </ng-template>

                </div>
            </div>

        </div>
    </div>
</div>
<!-- end -->


<!--<style>
    .skills-input-wrapper {
        position: relative; /* Essential for dropdown positioning */
        display: inline-block;
    }

    .autocomplete-dropdown {
        position: absolute;
        top: 100%; /* Position below the input */
        left: 0;
        z-index: 1000;
        list-style: none;
        padding: 0;
        margin: 0;
        border: 1px solid #ccc;
        background-color: white;
        max-height: 200px;
        overflow-y: auto;
        width: 100%; /* Match the input width */
    }

        .autocomplete-dropdown li {
            padding: 8px 12px;
            cursor: pointer;
        }

            .autocomplete-dropdown li:hover {
                background-color: #f0f0f0;
            }
</style>-->
